import React from 'react';

// Helpers
import { closeDrawer, getURLSegment } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';
import LocationEdit from '../Locations/Edit';
import ScheduleManage from '../Schedule/ScheduleManage';
import MessagesDetail from '../Messages/MessagesDetail';
import MessageThread from '../Messages/MessageThread';
import SessionDetail from '../Sessions/SessionDetail';
import PaymentForm from '../Payments/PaymentForm';
import SupportTicketDetail from '../SupportTickets/SupportTicketDetail';
import AddSupportTicket from '../SupportTickets/AddSupportTicket';
import ReportFilter from '../Reports/ReportFilter';
import UserEdit from '../Users/EditUsers';
import CreateUser from '../Users/CreateUser';
import Session from '../Sessions/Session';
import Checkout from '../Checkout/Checkout.js';

class Drawer extends React.Component {
  render() {
    const { content, isOpen, translation } = this.props;
    let closeBtnClass = null;
    let closePath = null;

    const DrawerComponents = {
      LocationEdit: LocationEdit,
      ScheduleManage: ScheduleManage,
      MessagesDetail: MessagesDetail,
      MessageThread: MessageThread,
      SessionDetail: SessionDetail,
      PaymentForm: PaymentForm,
      SupportTicketDetail: SupportTicketDetail,
      AddSupportTicket: AddSupportTicket,
      ReportFilter: ReportFilter,
      UserEdit: UserEdit,
      CreateUser: CreateUser,
      Session: Session,
      Checkout: Checkout
    }

    if(
        content === 'SupportTicketDetail' ||
        content === 'AddSupportTicket' ||
        content === 'LocationEdit' ||
        content === 'ScheduleManage' ||
        content === 'MessageDetail' ||
        content === 'UserEdit' ||
        content === 'CreateUser' ||
        (content === 'SessionDetail' && getURLSegment(this, 1) === 'sessions')
      ) {
      closePath = getURLSegment(this, 1);
    }

    if(isOpen) {
      setTimeout(function(){
        document.querySelector('body').className += ' drawer-open';
      })
    }

    if(content) {
      const { large, store } = this.props;
      const { SessionStore } = store;
      const DrawerComponent = DrawerComponents[content];

      return(
        <aside id={content} className={`drawer ${large ? 'drawer--large' : ''}`}>
          {!SessionStore.hideDrawerClose &&
            <button
              className={`drawer__close ${closeBtnClass}`}
              onClick={(e) => closeDrawer(
                e, this.props.parent, closePath, this.props.callback
              )}
            >
                <icons.iconTimes />
                <span className="meta">{translation.close}</span>
            </button>
          }

          <DrawerComponent {...this.props} drawer={true} />
        </aside>
      )
    } else {
      return null;
    }
  }
}

export default translate('Drawer')(Drawer);



// WEBPACK FOOTER //
// ./src/app/components/Drawer/Drawer.js